/*
 * Copyright (c) 2025 Autire Technologies, LLC. All Rights Reserved.
 *
 * This product and related documentation is protected by copyright and
 * distributed under licenses restricting its use, copying, distribution and
 * decompilation. No part of this product or related documentation may be
 * reproduced in any form by any means without prior written authorization
 * from Autire Technologies, LLC and/or its licensors.
 */

import React, { Component } from 'react';
import AppContent from '../components/AppContent';
import AppHeader from '../components/AppHeader';
import { connect } from 'react-redux';
import { accountActions } from '../actions';
import 'DefaultLayout.scss';

class DefaultLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleOnAction = this.handleOnAction.bind(this);
    this.handleOnIdle = this.handleOnIdle.bind(this);
    this.logout = this.logout.bind(this);
  }

  logout() {
    this.props.logout((error) => {
      if (!error) {
        localStorage.clear();
        this.props.navigate('/login');
      }
    });
  }

  handleOnAction() {
    localStorage.setItem('sessionKey', new Date().getTime());
  }

  handleOnIdle() {
    let idleTime = parseInt(localStorage.getItem('sessionKey'));
    let currentTime = new Date().getTime();
    let timeDiff = currentTime - idleTime;
    let timeInMins = timeDiff / 60000;
    if (timeInMins > 115) {
      this.logout();
    }
  }
  render() {
    return (
      <div>
        {/* <IdleTimer
          timeout={1000 * 60 * 60 * 2}
          onActive={this.handleOnActive}
          onIdle={this.handleOnIdle}
          onAction={this.handleOnAction}
          debounce={2500}
        /> */}
        <div className="HomeImageContainer">
          <AppHeader toggleAside={this.toggleAside} {...this.props} />
          <div style={{ width: '100%', display: 'flex', flexDirection: 'column', height: '100%' }}>
            <AppContent {...this.props} />
          </div>
        </div>
        {/* <AppFooter /> */}
      </div>
    );
  }
}

// Mapping dispatch functions to props to access easily
const mapDispatchToProps = (dispatch) => ({
  logout: (callback) => dispatch(accountActions.logout(callback)),
});

export { DefaultLayout };
export { mapDispatchToProps };
export default connect(null, mapDispatchToProps)(DefaultLayout);
